module.exports = "<my-paperworkonlymovelineitem-grid (lineItemsChanged)=\"onLineItemsChanged($event)\"></my-paperworkonlymovelineitem-grid>"